import getOnCallTeamStore from "../../../../stores/developer-store/on-call-team-store";
import Et3Button from "../../../../core/et3-button";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";

const OnCallTeamForm = withLiteObserverAndTheme(() => {
  const disableUpdateButton = !getOnCallTeamStore().isOnCallChanged.get();

  return (
    <Et3Button
      size="LARGE"
      type="APPROVE"
      onClick={async () => await getOnCallTeamStore().updateOnCallTeamMember()}
      isEnabled={!disableUpdateButton}
      text="UPDATE_ON_CALL_TABLE"
    />
  );
});

export default OnCallTeamForm;
